import {
	createSlice,
	createSelector,
	createAsyncThunk,
} from "@reduxjs/toolkit";
import {
	deleteForm,
	getFormsByPersonId,
	getSMOLeaveFormsByPersonId,
	updateFormStatus,
} from "api";
import dayjs from "dayjs";

export const fetchMyLeaveHistory = createAsyncThunk(
	"myHistory/fetchMyLeaveHistory",
	//need the thunkApi's getState to retrieve auth token
	async (personId, { rejectWithValue, dispatch }) => {
		try {
			const data = await getSMOLeaveFormsByPersonId({ personId });
			dispatch(myLeaveHistoryReceived(data));
			return data;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const fetchMyHistory = createAsyncThunk(
	"myHistory/fetchMyHistory",
	//need the thunkApi's getState to retrieve auth token
	async (personId, { rejectWithValue, dispatch }) => {
		try {
			const data = await getFormsByPersonId({ personId });
			dispatch(myHistoryReceived(data));
			return data;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const postFormStatus = createAsyncThunk(
	"myHistory/postFormStatus",
	async (data, { rejectWithValue, dispatch }) => {
		try {
			const { formGuid, status, type, personId } = data;
			const response = await updateFormStatus({ formGuid, status });
			if (type === "Leave") dispatch(fetchMyLeaveHistory());
			else dispatch(fetchMyHistory(personId));
			return response;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

export const postDeleteForm = createAsyncThunk(
	"myHistory/postDeleteForm",
	async (data, { rejectWithValue, dispatch }) => {
		try {
			const { formGuid, type, personId } = data;
			const response = await deleteForm({ formGuid });
			if (type === "Leave") dispatch(fetchMyLeaveHistory());
			else dispatch(fetchMyHistory(personId));
			return response;
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const initialState = {
	status: "idle",
	error: null,
	data: [],
	leaveData: [],
};

const myHistorySlice = createSlice({
	name: "myHistory",
	initialState,
	reducers: {
		myHistoryReceived(state, action) {
			state.data = [...action.payload];
		},
		myLeaveHistoryReceived(state, action) {
			state.leaveData = [...action.payload];
		},
	},
	extraReducers: {
		[fetchMyHistory.pending]: (state, action) => {
			state.status = "loading";
			state.error = null;
		},
		[fetchMyHistory.fulfilled]: (state, action) => {
			state.status = "idle";
			state.error = null;
		},
		[fetchMyHistory.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
		[fetchMyLeaveHistory.pending]: (state, action) => {
			state.status = "loading";
			state.error = null;
		},
		[fetchMyLeaveHistory.fulfilled]: (state, action) => {
			state.status = "idle";
			state.error = null;
		},
		[fetchMyLeaveHistory.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
		[postFormStatus.pending]: (state, action) => {
			state.status = "loading";
			state.error = null;
		},
		[postFormStatus.fulfilled]: (state, action) => {
			state.status = "idle";
			state.error = null;
		},
		[postFormStatus.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
		[postDeleteForm.pending]: (state, action) => {
			state.status = "loading";
			state.error = null;
		},
		[postDeleteForm.fulfilled]: (state, action) => {
			state.status = "idle";
			state.error = null;
		},
		[postDeleteForm.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
	},
});

export const { myHistoryReceived, myLeaveHistoryReceived } =
	myHistorySlice.actions;

export const selectMyHistory = (state) => state.cme.myHistory.data;
export const selectMyLeaveHistory = (state) => state.cme.myHistory.leaveData;

export const selectMyHistoryStatus = (state) => state.cme.myHistory.status;
export const selectMyHistoryError = (state) => state.cme.myHistory.error;

export const selectOpenFormsCount = createSelector(
	[selectMyHistory],
	(mh) =>
		mh.filter(
			(f) =>
				dayjs(f.endDate) >= dayjs() && ![5, 6, 7].includes(f.formTypeId)
		).length
);

export default myHistorySlice.reducer;
